import { OrgTeamDetailsWithPaymentPlanQuery } from '@app/graphql/types-and-hooks';
import { OrgSpace, PageInfo } from '@app/routes/organization/domain';
import { TransactionState } from '@app/store/domain';

export type OrgRole = 'ADMIN' | 'MEMBER';

export type InviteMemberPayload = {
  email: string;
  role?: OrgRole;
  organizationId: string;
  spaceExternalIds?: string[];
};

export type { OrgSpace } from '@app/routes/organization/domain';

export type InviteMemberFormError = {
  field: 'email' | 'role' | 'root';
  message: string;
};

export type InviteMemberFormState = {
  isModalOpen: boolean;
  isSubmitting: boolean;
  isSuccess: boolean;
  errors: InviteMemberFormError[];
};

export type State = {
  auditExport: {
    error: {
      message: string;
    };
  } & TransactionState;
  inviteMemberForm: InviteMemberFormState;
  organisationPaymentDetails: {
    data: OrgTeamDetailsWithPaymentPlanQuery['organization'] | null;
    error: {
      message: string;
    };
  } & TransactionState;
  manageableSpaces: {
    spaces: OrgSpace[];
    pageInfo: PageInfo;
  } & TransactionState;
};

export const defaultInviteMemberFormState: InviteMemberFormState = {
  isModalOpen: false,
  isSubmitting: false,
  isSuccess: false,
  errors: [],
};

export const defaultState: State = {
  auditExport: {
    status: 'idle',
    error: {
      message: '',
    },
  },
  inviteMemberForm: defaultInviteMemberFormState,
  organisationPaymentDetails: {
    status: 'idle',
    data: null,
    error: {
      message: '',
    },
  },
  manageableSpaces: {
    status: 'idle',
    spaces: [],
    pageInfo: {
      hasNextPage: false,
      endCursor: null,
    },
  },
};
